module.exports = __webpack_public_path__ + "static/img/app.3fb62a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app.png
// module id = gNbn
// module chunks = 0